(ns app.front.view.party.assign-role
  (:require [app.domain.party.model :as party-model]
            [app.front.process :as process]
            [app.front.ui.select :as ui-select]
            [app.front.util :refer [for-frag]]
            [app.front.view.party.common :as common]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx
  ::assign-party-role
  (fn [_ [_ role-id party-id target-id add?]]
    {:dispatch [::process/signal
                target-id
                (if add?
                  [:process.signal/add-party-role
                   {:role-id  role-id
                    :party-id party-id}]
                  [:process.signal/remove-party-role
                   {:role-id  role-id
                    :party-id party-id}])
                {:notify {:success (if add?
                                     :party/successfully-assigned
                                     :party/successfully-unassigned)}}]}))

(rf/reg-sub ::show-help-text?
  (fn [db [_ party-id]]
    (get-in db [::show-help-text? party-id])))

(rf/reg-event-db
  ::show-help-text
  (fn [db [_ party-id]]
    (assoc-in db [::show-help-text? party-id] true)))

(rf/reg-event-db
  ::hide-help-text
  (fn [db [_ party-id]]
    (update db ::show-help-text? #(dissoc % party-id))))

(rf/reg-event-fx ::hide-help-text-later
  (fn [_ [_ party-id]]
    {:dispatch-later {:ms 2000 :dispatch [::hide-help-text party-id]}}))

(defn role-row [{:keys [party assign-role lang tr role-id target-id]}]
  (let [checked?        (party-model/has-role? party (:party-role/key assign-role))
        role-count      (-> party :party/party-roles count)
        party-id        (:db/id party)
        last-role?      (and checked?
                             (= role-count 1))
        full-name       (party-model/business-or-full-name party lang)
        label           (str (if (str/blank? full-name) (:party/email party) full-name)
                             (str/lower-case (str " (" role-count " " (if (= role-count 1) (tr [:party/role]) (tr [:party/roles])) ")")))
        show-help-text? (<sub [::show-help-text? party-id])]
    [:div
     [:div.flex-row.p-2.rounded-md.mb-2.leading-9
      {:data-cy "single-party-to-the-role"
       :class   (when checked? "bg-ui-night-sky text-white")}
      (if last-role?
        [:div.cursor-pointer
         {:on-click #(do
                       (>evt [::show-help-text party-id])
                       (>evt [::hide-help-text-later party-id]))}
         [:div.flex (cc/icon {:icon        i/lock
                              :description ""
                              :fill        "white"
                              :class-name  "ml-1 mr-2 mt-2"})
          [:div label]]]
        (cc/checkbox {:key             (str party-id role-id)
                      :id              (str party-id "-party-box")
                      :label-text      label
                      :on-change       #(>evt [::assign-party-role role-id (:db/id party) target-id %])
                      :default-checked checked?}))]
     (when show-help-text?
       [:div.flex-row.font-bold.text-ui-red-100
        (tr [:party/role-remove-help-text])])]))

(defn assign-modal [tr target existing-parties]
  (let [target-id   (:db/id target)
        open?       (or (<sub [::common/assign-open]) false)
        role-id     (<sub [::common/assign-role])
        party-roles (<sub [::ws-subs/sorted-party-roles])
        assign-role (p/find-first party-roles #(= (:db/id %) role-id))
        lang        (<sub [:language])]
    [:div
     (cc/composed-modal
       {:open     open?
        :on-close #(>evt [::common/close])}
       (cc/modal-header {:close-modal #(>evt [::common/close])
                         :title       (tr [:party/assign-roles])})
       (cc/modal-body
         {}
         [:div
          [:div.flex-row.border-b.border-solid.border-gray-600.pb-8.my-4
           [:div.flex.mb-2
            [:div (tr [:party/choose-role])]]
           [:div.flex
            (if (<sub [::ws-subs/loading-config?])
              (cc/select-skeleton {:hide-label true})
              [ui-select/select {:id           "assign-role"
                                 :class-name   "full-width-select"
                                 :select-text  (tr [:party/choose-role])
                                 :label-text   ""
                                 :hide-label   true
                                 :value        assign-role
                                 :on-change    #(>evt [::common/set-doc-value [::common/assign-role] (:db/id %)])
                                 :val->str     #(i18n-model/get-text-from-entities-or-map (:party-role/names %) lang)
                                 :allow-empty? true
                                 :values       party-roles
                                 :disabled     false}])]]
          (when assign-role
            [:div.flex-row.border-b.border-solid.border-gray-600.pb-6.my-4
             [:div.flex.mb-2
              [:div (tr [:party/select-parties-to-role])]]
             [:div
              (for-frag [party (filter party-model/active? existing-parties)]
                [role-row (util/mmap party assign-role lang tr role-id target-id)])]])
          [:div.flex-row
           [common/assign-buttons (util/mmap tr)]]]))]))
